import React from 'react';
import ReactDOM from 'react-dom/client';
import CorazonWTF from './corazon-wtf';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CorazonWTF />
  </React.StrictMode>
);
